export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const FIRST_SIGN_UP_WITH_QAUTH = 'sign-up-with-qauth';
export const NODE_WAS_UPDATED_IN_INSIGHTS = 'node_was_updated_in_insights';
export const STANDARD_REF_UPDATED_IN_INSIGHTS =
  'standard_ref_updated_in_insights';
export const OAUTH_LOGIN_TYPE = 'loginType';
export const COOKIES_ACCEPTED = 'cookies-accepted';
